export const getHandleReactIntlOnError = ({ trace = false } = {}) => {
    const errorBasket = new Set()
    let errorTimer = null

    return error => {
        errorBasket.add(error)
        if (trace) {
            console.error(error)
        }
        if (!errorTimer) {
            setTimeout(() => {
                if (errorBasket.size > 0) {
                    console.error([...errorBasket].join('\n'))
                }
                errorBasket.clear()
                errorTimer = null
            }, 200)
        }
    }
}
